"use client";

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trackExistingUser } from "../config/redux/slices/authAndAddressSlice";

export default function ExistingUserTracker() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (token && !hasTracked.current) {
      // Check if just logged in, skip to avoid duplicate
      const justLoggedIn = localStorage.getItem("justLoggedIn");
      if (justLoggedIn === "true") {
        localStorage.removeItem("justLoggedIn");
        hasTracked.current = true; // Prevent future calls
        return;
      }
      // User is logged in, track as existing user only once per session
      dispatch(trackExistingUser());
      hasTracked.current = true;
    }
  }, [token, dispatch]);

  return null; // This component doesn't render anything
}